import { defineMessages } from 'react-intl';

export const libraryArtefactsMessages = defineMessages({
  tabLabel: {
    defaultMessage: 'Artefacts',
    id: 'l3WaV0keX0',
    description: 'Library tab for Heidi Work saved artefacts',
  },
  emptyTitle: {
    defaultMessage: 'No artefacts yet',
    id: 'dqdX7U5M59',
    description: 'Empty state title for the Library Artefacts tab',
  },
  emptyDescription: {
    defaultMessage:
      'Artefacts saved by Heidi, including handovers, agent outputs, and skill files, appear here. They are stored in your library but are not used in Evidence answers.',
    id: 'bWmwWQEH32',
    description: 'Empty state description for the Library Artefacts tab',
  },
  allArtefactsHeading: {
    defaultMessage: 'All artefacts',
    id: '9y8jXj9bCy',
    description: 'Section heading listing all saved Heidi Work artefacts',
  },
  workOutputsDescription: {
    defaultMessage:
      'Handovers, agent outputs, and skill files saved by Heidi. These are stored in your library but not used in Evidence answers.',
    id: '7dtLbhuZtj',
    description: 'Library Artefacts section description for agent-generated documents',
  },
  artefactCollectionsTitle: {
    defaultMessage: 'Artefact collections',
    id: '7UZ/cczUd4',
    description: 'Library section title for agent-generated artefact collections',
  },
  createFolderHint: {
    defaultMessage:
      'Heidi outputs you save or move here will show up in this folder. Web sources for Evidence do not belong here.',
    id: 'S5qpXKjSoJ',
    description: 'Hint in the create-collection modal when making an artefact folder',
  },
});
